export const load = () => ({
	title: 'Window Privacy Ideas for Urban Living',
	showTitle: true,
});
